import React, { useState } from 'react';
import { Upload, FolderOpen } from 'lucide-react';

export default function FileDropZone({
  mode,
  inputText,
  inputRef,
  onFileChange,
  onDrop,
  onDragOver,
  disabled
}) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    setIsDragging(false);
    onDrop(e);
  };

  const Icon = mode === 'folder' ? FolderOpen : Upload;
  const inputId = mode === 'folder' ? 'folderInput' : 'fileInputIndividual';
  const acceptProps = mode === 'folder'
    ? { webkitdirectory: '', directory: '', multiple: true }
    : { accept: '.png,.heic,.heif,.webp,.avif,.jpeg,.jpg,.gif,.bmp' };

  return (
    <div
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={onDragOver}
      onDrop={handleDrop}
    >
      <label
        htmlFor={inputId}
        className={`flex flex-col items-center justify-center p-8 border-2 border-dashed rounded-xl cursor-pointer transition-all duration-300 ${
          isDragging
            ? 'border-indigo-400 bg-indigo-500/10 scale-[1.02]'
            : 'border-slate-600 bg-slate-800/30 hover:border-indigo-500/50 hover:bg-slate-700/30'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        aria-label={mode === 'folder' ? 'Select a folder with image files' : 'Select an image file to convert'}
      >
        <Icon size={36} className={`mb-3 ${isDragging ? 'text-indigo-400' : 'text-gray-500'} transition-colors`} />
        <span className={`text-sm ${isDragging ? 'text-indigo-300' : 'text-gray-400'}`}>{inputText}</span>
        <span className="text-xs text-gray-600 mt-1">PNG, HEIC, WebP, AVIF, JPEG, GIF, BMP</span>
        <input
          type="file"
          id={inputId}
          ref={inputRef}
          onChange={onFileChange}
          className="hidden"
          disabled={disabled}
          {...acceptProps}
        />
      </label>
    </div>
  );
}
